import { Stack } from '@mui/material'
import ReassignExamHeader from './ReassignExamHeader'
import ReassignExamFooter from './ReassignExamFooter'
import { Fragment, useState } from 'react'
import ReassignExam from './ReassignExam'
import { useStepper } from '@common/context/StepperContext'
import { ContainerParam } from '@features/subject/subject.types'
import { useForm, FormProvider } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  ExamReassignementFormValidationSchema,
  ExamReassignementFormValues,
} from '../../schemas/ExamReassignementEsignValidationSchema'
import { useParams } from 'react-router-dom'

export default function ReassignExamLayout({
  subjectPseudoId,
  assignableTimepointSubmissions,
  handleClose,
  containers,
}: {
  subjectPseudoId?: string
  assignableTimepointSubmissions: string[]
  containers?: ContainerParam[]
  handleClose: () => void
}) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { activeStep, setActiveStep, steps } = useStepper()
  const { timepointSubmissionId } = useParams<{ timepointSubmissionId: string }>()

  // Initialize form with react-hook-form
  const methods = useForm<ExamReassignementFormValues>({
    resolver: zodResolver(ExamReassignementFormValidationSchema),
    defaultValues: {
      exam_metadata_ids: [],
      from_timepoint_submission: {},
      to_timepoint_submission: {
        timepoint_submission_id: '',
      },
      selected_subject_id: undefined,
    },
    mode: 'onChange',
  })

  const handleContinue = () => {
    if (activeStep < steps.length - 1) {
      // Move to the next step
      setActiveStep(activeStep + 1)
    } else {
      // On the last step - handle is moved to the footer component
      setIsSubmitting(true)
    }
  }

  return (
    <Fragment>
      <FormProvider {...methods}>
        <ReassignExamHeader handleClose={handleClose} isSubmitting={isSubmitting} subjectPseudoId={subjectPseudoId} />
        <Stack
          bgcolor={'background.paper'}
          paddingTop={6}
          paddingBottom={8}
          width={'100%'}
          height={'100%'}
          alignItems={'center'}
          overflow={'hidden'}
        >
          <ReassignExam
            containers={containers}
            assignableTimepointSubmissions={assignableTimepointSubmissions}
            currentTimepointSubmissionId={timepointSubmissionId}
          />
        </Stack>
        <ReassignExamFooter
          handleContinue={handleContinue}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          handleClose={handleClose}
        />
      </FormProvider>
    </Fragment>
  )
}
